var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('router-view'),_c('vue-element-loading',{attrs:{"active":_vm.isActiveLoader,"is-full-screen":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }